export type FileInputEventTarget = {
  addEventListener: (event: string, listener: EventListener) => void;
  removeEventListener: (event: string, listener: EventListener) => void;
};

export const MAX_IMPORT_FILES = 5;

export const getImportFileLimit = (isSubscribed: boolean): number =>
  isSubscribed ? MAX_IMPORT_FILES : 1;

export const limitImportFiles = <FileType>(
  files: FileType[],
  maxFiles: number = MAX_IMPORT_FILES,
): FileType[] => files.slice(0, maxFiles);

export const attachFilePickerEvents = (
  target: FileInputEventTarget,
  handlers: { change: EventListener; cancel: EventListener }
): (() => void) => {
  /* action-id: lifecycle.filePicker.result */ target.addEventListener(
    "change",
    handlers.change
  );
  /* action-id: lifecycle.filePicker.result */ target.addEventListener(
    "cancel",
    handlers.cancel
  );
  return () => {
    target.removeEventListener("change", handlers.change);
    target.removeEventListener("cancel", handlers.cancel);
  };
};
